angular.module('picmonic-common')
    .factory("MetatagResource", ['$resource', function($resource){
        return $resource("/api/v3/metatags");
    }]);